import React, { useState } from 'react'
import './Learning.scss';
import { IoFilter } from 'react-icons/io5';
import { FiList } from "react-icons/fi";
import { IoIosArrowDown } from 'react-icons/io';
import { FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';


const learningData: Course[] = [
  {
    name: "Mastering Focus & Productivity",
    description: "Learn science-backed techniques to eliminate distractions, manage your time better, and boost deep work sessions.",
    subDescription: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
    complete: 8,
    image: "/images/course_img.jpg",
    learningContent: [
      {
        title: "Introduction to Focus & Productivity",
        lectures: [
          {
            id: 1,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 2,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 3,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Breaking Procrastination Loops",
        lectures: [
          {
            id: 4,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 5,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 6,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Deep Work Techniques",
        lectures: [
          {
            id: 7,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 8,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 9,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Introduction to Focus & Productivity",
        lectures: [
          {
            id: 10,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 11,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 12,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
    ]
  },
  {
    name: "Emotional Intelligence at Work",
    description: "Understand and apply emotional intelligence to build better relationships and manage workplace stress.",
    subDescription: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
    complete: 42,
    image: "/images/course_img.jpg",
    learningContent: [
      {
        title: "Introduction to Focus & Productivity",
        lectures: [
          {
            id: 13,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 14,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 15,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Breaking Procrastination Loops",
        lectures: [
          {
            id: 16,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 17,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 18,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Deep Work Techniques",
        lectures: [
          {
            id: 19,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 20,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 21,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Introduction to Focus & Productivity",
        lectures: [
          {
            id: 22,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 23,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 24,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
    ]
  },
  {
    name: "Effective Communication Skills",
    description: "Master verbal and non-verbal communication strategies to boost your confidence and influence.",
    subDescription: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
    complete: 75,
    image: "/images/course_img.jpg",
    learningContent: [
      {
        title: "Introduction to Focus & Productivity",
        lectures: [
          {
            id: 25,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 26,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 27,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Breaking Procrastination Loops",
        lectures: [
          {
            id: 28,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 29,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 30,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Deep Work Techniques",
        lectures: [
          {
            id: 31,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 32,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 33,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Introduction to Focus & Productivity",
        lectures: [
          {
            id: 34,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 35,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 36,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
    ]
  },
  {
    name: "Time Management Essentials",
    description: "Learn proven frameworks to prioritize tasks, set achievable goals, and increase daily productivity.",
    subDescription: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
    complete: 90,
    image: "/images/course_img.jpg",
    learningContent: [
      {
        title: "Introduction to Focus & Productivity",
        lectures: [
          {
            id: 25,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 26,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 27,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Breaking Procrastination Loops",
        lectures: [
          {
            id: 28,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 29,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 30,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Deep Work Techniques",
        lectures: [
          {
            id: 31,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 32,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 33,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Introduction to Focus & Productivity",
        lectures: [
          {
            id: 34,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 35,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 36,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
    ]
  },
  {
    name: "Mindfulness for Everyday Life",
    description: "Develop mindfulness habits to reduce stress, improve focus, and live in the present moment.",
    subDescription: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
    complete: 20,
    image: "/images/course_img.jpg",
    learningContent: [
      {
        title: "Introduction to Focus & Productivity",
        lectures: [
          {
            id: 25,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 26,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 27,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Breaking Procrastination Loops",
        lectures: [
          {
            id: 28,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 29,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 30,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Deep Work Techniques",
        lectures: [
          {
            id: 31,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 32,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 33,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Introduction to Focus & Productivity",
        lectures: [
          {
            id: 34,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 35,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 36,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
    ]
  },
  {

    name: "Leadership & Influence",
    description: "Build strong leadership qualities to inspire teams, drive change, and lead with integrity.",
    subDescription: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
    complete: 40,
    image: "/images/course_img.jpg",
    learningContent: [
      {
        title: "Introduction to Focus & Productivity",
        lectures: [
          {
            id: 25,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 26,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 27,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Breaking Procrastination Loops",
        lectures: [
          {
            id: 28,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 29,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 30,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Deep Work Techniques",
        lectures: [
          {
            id: 31,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 32,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 33,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
      {
        title: "Introduction to Focus & Productivity",
        lectures: [
          {
            id: 34,
            type: "Video",
            title: "Overview of common distractions & productivity myths",
            showType: "./videos/video.mp4"
          },
          {
            id: 35,
            type: "Video",
            title: "How your brain processes focus, multitasking, and flow",
            showType: "./videos/video.mp4"

          },
          {
            id: 36,
            type: "Note",
            title: "Why we delay tasks & simple hacks to get started",
            showType: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia beatae numquam aspernatur id ratione in omnis officia dolor optio, quis necessitatibus consequuntur enim ullam? Illo sequi, consequuntur quis cupiditate ipsum aliquam deleniti, earum porro, impedit corporis nihil. Ipsum quaerat, labore dolorum quibusdam sed dolore odio recusandae vitae quo perferendis. Quo in aspernatur veniam velit sunt, expedita dolorum, deserunt nihil sequi, dicta libero ipsa. Animi corporis dolore libero quae officia expedita ut, quis voluptates vero illum minus asperiores quam exercitationem vitae nesciunt sit commodi nam qui voluptatum ab, fuga repudiandae. Est non dicta repellat unde ratione! Eveniet vitae sit odio harum.",
          },
        ],
      },
    ]
  },
];

interface Lecture {
  id: number;
  type: "Video" | "Note";
  title: string;
  showType: string;
}


interface LearningContent {
  title: string;
  lectures: Lecture[];
}


interface Course {
  name: string;
  description: string;
  subDescription: string;
  complete: number;
  image: string;
  learningContent: LearningContent[];
}

function Learning() {

  const navigate = useNavigate();

  const [openSections, setOpenSections] = useState<number[]>([]);
  const [selectedLearning, setSelectedLearning] = useState<Course | null>(null);
  const [selectedLecture, setSelectedLecture] = useState<Lecture | null>(null);
  const [fillter, setFilter] = useState<boolean>(false)

  const toggleSection = (id: number) => {
    if (openSections.includes(id)) {
      setOpenSections(openSections.filter((sectionId) => sectionId !== id));
    } else {
      setOpenSections([...openSections, id]);
    }
  };

  return (
    <div className="learning_information">
      {/* Course list page */}
      {!selectedLearning && (
        <div className="learning_page">
          <div className="learning_header">
            <div className="learning_title">
              <p className="main_title">My Learning</p>
              <p className="sub_title">
                Continue where you left off and track your progress in each
                course.
              </p>
            </div>

            <div className="learning_filters">
              <select className="filter_select">
                <option value="">Popular</option>
                <option value="">Newest</option>
                <option value="">Trending</option>
              </select>
              <button className="filter_btn">
                <IoFilter />
                <span>Filters</span>
              </button>
            </div>
          </div>

          <div className="learning_cards">
            {learningData.map((course, index) => (
              <div
                className="learning_card"
                key={index}
                onClick={() => {
                  setSelectedLearning(course);
                  if (
                    course.learningContent?.length > 0 &&
                    course.learningContent[0].lectures?.length > 0
                  ) {
                    setSelectedLecture(course.learningContent[0].lectures[0]);
                  }
                  setOpenSections([0]);
                }}
              >
                <img
                  src={course.image}
                  alt={course.name}
                  className="learning_image"
                />
                <p className="course_name">{course.name}</p>
                <p className="course_description">{course.description}</p>
                <div className="progress_bar">
                  <div className="progress">
                    <div
                      className="progress_fill"
                      style={{ width: `${course.complete}%` }}
                    ></div>
                  </div>
                  <p className="progress_text">{course.complete}% complete</p>
                </div>
                <button className="continue_btn">Continue Learning</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Single course page */}
      {selectedLearning && (
        <div className="course_container">
          {/* Left Section */}
          <div className="course_left">
            <div className="course_info">
              <div className="course_title_filter">
                <p className="course_title">{selectedLearning.name}</p>
                <div
                  className="filter_svg"
                  onClick={() => setFilter(!fillter)}
                >
                  <FiList />
                </div>
              </div>
              <div className="course_subdesc">
                {selectedLecture && (
                  <div className="lecture_player">
                    <p className="lecture_title">{selectedLecture.title}</p>
                    {selectedLecture.type === "Video" ? (
                      <video
                        className="lecture_video"
                        controls
                        src={selectedLecture.showType}
                      />
                    ) : (
                      <p className="lecture_note">{selectedLecture.showType}</p>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="course_actions">
              <button className="next_btn">
                Go to next item <FaArrowRight />
              </button>
            </div>
          </div>

          {/* Right Section */}
          <div className={`course_right ${fillter ? "show" : ""}`}>
            <button className="close_btn" onClick={() => setFilter(false)}>
              ✕
            </button>

            {selectedLearning.learningContent.map((content, i) => (
              <div className="content" key={i}>
                <div onClick={() => { toggleSection(i); navigate("/learning", { state: { courseTitle: content.title } }) }} className="content_header">
                  <IoIosArrowDown
                    className={`arrow ${openSections.includes(i) ? "rotate" : ""
                      }`}
                  />
                  <p className="content_title">{content.title}</p>
                </div>

                {openSections.includes(i) && (
                  <div className="lectures_list">
                    {content.lectures.map((lecture, k) => (
                      <div
                        onClick={() => {
                          setSelectedLecture(lecture);
                          setFilter(false);
                        }}
                        className={`lecture_item ${selectedLecture?.id === lecture.id ? "active" : ""
                          }`}
                        key={k}
                      >
                        <input
                          type="radio"
                          checked={selectedLecture?.id === lecture.id}
                          readOnly
                        />
                        <p className="lecture_name">{lecture.title}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default Learning